import style from './style.module.scss'
import { useParams } from 'react-router'
import EditorCore from 'src/Components/ForPages/CaseStudy/ContentEditorV2'
import { useGetCaseStudyQuery } from 'src/redux/Api/caseStudiesApi'
import MainInfoForm from 'src/Components/ForPages/CaseStudy/MainInfoForm'
import AdditionalInfo from 'src/Components/ForPages/CaseStudy/AdditionalInfo'
import { useState } from 'react'
import Tabs from 'src/Components/Tabs'

const CaseStudy = () => {
  const { id } = useParams()
  if (!id) return null
  const { data } = useGetCaseStudyQuery(+id)
  const [tab, setTab] = useState(0)

  return (
    <>
      <h1>CaseStudy {id}</h1>
      {data && (
        <section className={style.case_study + ' block'}>
          <Tabs name="case_study" list={['Main Info', 'Content', 'Result']} baseItem={tab} onChange={setTab} />
          {tab === 0 && (
            <>
              <MainInfoForm data={data} />
              <AdditionalInfo data={data} />
            </>
          )}
          {tab === 1 && data.content && (
            <EditorCore
              data={{
                id: data.content.id,
                caseStudyId: data.content.caseStudyId,
                content: data.content.content
              }}
              type="content"
            />
          )}
          {tab === 2 && data.content && (
            <EditorCore
              data={{
                id: data.content.id,
                caseStudyId: data.content.caseStudyId,
                content: data.content.result
              }}
              type="result"
            />
          )}
        </section>
      )}
    </>
  )
}

export default CaseStudy
